import { render, staticRenderFns } from "./detail_news.vue?vue&type=template&id=1c4c49e8&"
import script from "./detail_news.vue?vue&type=script&lang=js&"
export * from "./detail_news.vue?vue&type=script&lang=js&"
import style0 from "./detail_news.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports